import type { ShiftDropoff } from "@domain/CRM/dropoff";
import { API } from "@infra/api";
import type { IShifts } from "@ports/shifts/IShifts";
import type { IShiftDropoffs } from "@ports/shifts/IShiftDropoffs";
import type { IJobs } from "@ports/jobs/IJobs";
import { makeShiftsUseCases } from "@app/shifts";

const shiftsApi: IShifts = {
	createMany: (shifts) => API.Data.Shifts.create.many(shifts),
	updateMany: (shifts) => API.Data.Shifts.update.many(shifts),
};

// Dropoff-stop junction writes (create/re-link/delete) for the scheduling save.
const stopsApi: IShiftDropoffs = {
	createMany: (stops) => API.Data.ShiftDropoffs.create.many(stops),
	// Partial updates ride the same /update route — the API's model_fields_set semantics
	// treat omitted fields as untouched, so the cast only widens the wire payload type.
	updateMany: (stops) => API.Data.ShiftDropoffs.update.many(stops as ShiftDropoff[]),
	deleteMany: (ids) => API.Data.ShiftDropoffs.delete(ids).then(() => undefined),
};

// The scheduling save also writes the Jobs.Order projection, the Dropoffs/Shipping routing, and
// the cluster pull-in point.
const jobsApi: Pick<IJobs, "setOrders" | "setDropoffs" | "setLocations"> = {
	setOrders: (updates) => API.Data.Jobs.update.orders(updates),
	setDropoffs: (updates) => API.Data.Jobs.update.dropoffs(updates),
	setLocations: (updates) => API.Data.Jobs.update.locations(updates),
};

export const shiftsUseCases = makeShiftsUseCases({ shiftsApi, stopsApi, jobsApi });
